/*
 * Sonatype Nexus (TM) Open Source Version
 * Copyright (c) 2008-present Sonatype, Inc.
 * All rights reserved. Includes the third-party code listed at http://links.sonatype.com/products/nexus/oss/attributions.
 *
 * This program and the accompanying materials are made available under the terms of the Eclipse Public License Version 1.0,
 * which accompanies this distribution and is available at http://www.eclipse.org/legal/epl-v10.html.
 *
 * Sonatype Nexus (TM) Professional Version is available from Sonatype, Inc. "Sonatype" and "Sonatype Nexus" are trademarks
 * of Sonatype, Inc. Apache Maven is a trademark of the Apache Software Foundation. M2eclipse is a trademark of the
 * Eclipse Foundation. All other trademarks are the property of their respective owners.
 */

import React from 'react';
import { NxButton, NxButtonBar, NxFooter, NxH2, NxModal, NxWarningAlert } from '@sonatype/react-shared-components';

export default function CapabilitiesEditDeleteModal(
    { showModal, deleteWarningMessage, onConfirmDelete, onDeleteCanceled }
) {
  if (!showModal) {
    return false;
  }

  return <NxModal onCancel={onDeleteCanceled} aria-labelledby="modal-header-text">
    <NxModal.Header>
      <NxH2>Delete Capability?</NxH2>
    </NxModal.Header>

    <NxModal.Content>
      <NxWarningAlert>
        {buildMessage()}
      </NxWarningAlert>
    </NxModal.Content>

    <NxFooter>
      <NxButtonBar>
        <NxButton onClick={onDeleteCanceled}>Cancel</NxButton>
        <NxButton variant="primary" onClick={onConfirmDelete}>Delete</NxButton>
      </NxButtonBar>
    </NxFooter>
  </NxModal>

  function buildMessage() {
    return !deleteWarningMessage
      ? 'This will permanently remove this capability and its configuration. This action can’t be undone.'
      : deleteWarningMessage;
  }
}
